import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';

type LoadingStore = {
  isLoading: boolean;
  setLoading: (isLoading: LoadingStore['isLoading']) => void;

  content: string;
  setContent: (content: LoadingStore['content']) => void;
};

export const useLoadingStore = create<LoadingStore>()((set, get) => ({
  isLoading: false,
  setLoading: (isLoading: LoadingStore['isLoading']) => {
    set({ isLoading });
  },

  content: '',
  setContent: (value: LoadingStore['content']) => set({ content: value }),
}));
